import { render, staticRenderFns } from "./PhoneModal.vue?vue&type=template&id=aa6ce4b6&scoped=true&"
import script from "./PhoneModal.vue?vue&type=script&lang=js&"
export * from "./PhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6ce4b6",
  null
  
)

export default component.exports